import React from "react";
import { ArrowRight, GraduationCap, Sparkles } from "lucide-react";
import { ASSETS } from "@/lib/brand";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-28 sm:pt-32 lg:pt-36 pb-16 lg:pb-24"
    >
      {/* Background warm wash */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-paula-cream" />
        <div className="absolute -top-32 -left-24 w-[480px] h-[480px] rounded-full bg-paula-yellow-soft blur-3xl opacity-70" />
        <div className="absolute top-40 -right-24 w-[420px] h-[420px] rounded-full bg-paula-blue-soft blur-3xl opacity-60" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        {/* Left: text */}
        <div className="lg:col-span-7">
          <div className="rise rise-1 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-slate-200 text-xs font-semibold text-paula-ink/80 mb-6">
            <Sparkles size={14} className="text-paula-yellow" />
            Das Erste-Hilfe-Ausmalbuch für Kinder
          </div>

          <h1 className="rise rise-2 font-display font-bold text-paula-ink text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
            Bleib cool — das kannst auch{" "}
            <span className="text-paula-red">Du!</span>
          </h1>

          <p className="rise rise-3 mt-7 text-lg sm:text-xl text-paula-muted max-w-xl leading-relaxed">
            Rettungssanitäterin Pinguin Paula nimmt Kindern die Angst vor dem
            Notfall — und macht sie zu kleinen Helden. Spielerisch, warm und
            ehrlich. Mit Ausmalseiten, der HELD-Regel und einer 3D-Anmal-Paula.
          </p>

          <div className="rise rise-4 mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#shop"
              data-testid="hero-cta-buy"
              className="group inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-paula-ink text-white font-semibold text-base hover:bg-paula-red transition-colors"
            >
              Buch kaufen
              <ArrowRight
                size={18}
                className="transition-transform group-hover:translate-x-1"
              />
            </a>
            <a
              href="#schulen"
              data-testid="hero-cta-schools"
              className="group inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-white border-2 border-paula-ink text-paula-ink font-semibold text-base hover:bg-paula-yellow-soft transition-colors"
            >
              <GraduationCap size={18} />
              Schulen & Förderer
            </a>
          </div>

          {/* Tiny trust row */}
          <div className="rise rise-4 mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-paula-muted">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-paula-red" />
              Von Simone Faller · Autorin & Mama
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-paula-blue" />
              Erhältlich im Shop und bei Amazon.de
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-paula-yellow" />
              Ab 6 Jahren
            </div>
          </div>
        </div>

        {/* Right: Paula */}
        <div className="lg:col-span-5">
          <div className="relative mx-auto max-w-md">
            <div className="absolute inset-0 -m-6 rounded-[3rem] bg-white border border-slate-200 shadow-[0_24px_60px_-24px_rgba(15,23,42,0.25)]" />
            <div className="relative paula-bob">
              <img
                src={ASSETS.paulaCharacter}
                alt="Rettungssanitäterin Pinguin Paula"
                className="w-full h-auto drop-shadow-xl"
                data-testid="hero-paula-image"
              />
            </div>
            {/* Floating stickers */}
            <div className="absolute -top-2 -left-4 sm:-left-8 bg-paula-yellow text-paula-ink font-display font-bold text-sm px-4 py-2 rounded-2xl rotate-[-8deg] shadow-md">
              Hallo, ich bin Paula!
            </div>
            <div className="absolute -bottom-3 -right-2 bg-paula-blue text-white font-display font-bold text-xs px-3 py-2 rounded-2xl rotate-[6deg] shadow-md">
              112 = Hilfe holen
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
